<script setup lang="ts">
import { Icon } from '@collector/shared-ui'
import {
  CommonEventStatusId,
  CommonIncidentId,
} from '@collector/sportsapi-client-legacy'

import BetButton from './BetButton.vue'

const disabledStatuses = new Set([
  CommonEventStatusId.Abandoned,
  CommonEventStatusId.Cancelled,
])
</script>

<template>
  <BetButton
    class="min-w-34"
    betMarketEventKey="bet_status"
    betStatusActiveText="Close markets"
    betStatusInactiveText="Open markets"
    :openMarketsIncidentId="CommonIncidentId.Betstart"
    :closeMarketsIncidentId="CommonIncidentId.Betstop"
    :disabledStatuses
  >
    <Icon
      class="text-neutral-light-10 scale-x-[-1]"
      icon="lock-open"
    />
  </BetButton>
</template>
